import useNetworks, { useNetworkName } from '#/data/useNetworks';
import Skeleton from './Skeleton';

interface Props {
  symbol?: string;
}

export default function NetworkName({ symbol }: Props) {
  const { isLoading: isNetworksLoading } = useNetworks();
  const name = useNetworkName(symbol);
  return (
    <Skeleton isLoading={isNetworksLoading} className="w-16">
      <span>{name}</span>
    </Skeleton>
  );
}
